export class XMLHttpRequestFactory {

  public create(): XMLHttpRequest {
    return new XMLHttpRequest();
  }
}
